import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/global.css'
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import AppRoutes from './routes'
import theme from './theme/theme'
import ThemeWrapper from './theme/ThemeContext'
import { GlobalContextProvider } from "./operations/globalContext";



const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalContextProvider>
        <ThemeWrapper>
          <CssBaseline /> {/* resets MUI baseline styling */}
          <AppRoutes />
        </ThemeWrapper>
      </GlobalContextProvider>
    </BrowserRouter>
  </React.StrictMode>
)